import { useRef, useState, useEffect } from 'react';
import { auth, storage, db } from '../../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { addDoc } from 'firebase/firestore';
import { collection } from 'firebase/firestore';
import AnalyticsDashboard from '../AnalyticsDashboard';
import UniqueVisitorsList from '../UniqueVisitorsList';
import AnimatedLetters from '../AnimatedLetters';
import Loader from 'react-loaders';
import './home.scss';

const Home = () => {
  const [activeTab, setActiveTab] = useState('analytics');
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const form = useRef();
  const submitPortfolio = (e) => {
    e.preventDefault();
    const name = form.current[0]?.value;
    const description = form.current[1]?.value;
    const url = form.current[2]?.value;
    const image = form.current[3]?.files[0]; // Use files[0] to get the selected file

    const storageRef = ref(storage, `portfolio/ ${image.name}`);
    uploadBytes(storageRef, image).then(
      (snapshot) => {
        getDownloadURL(snapshot.ref).then(
          (downloadUrl) => {
            savePortfolio({
              name,
              description,
              url,
              image: downloadUrl,
            });
          },
          (error) => {
            alert(error);
            savePortfolio({
              name,
              description,
              url,
              image: null,
            });
          }
        );
      },
      (error) => {
        alert(error);
        savePortfolio({
          name,
          description,
          url,
          image: null,
        });
      }
    );
  };
  const savePortfolio = async (portfolio) => {
    console.log(portfolio);
    try {
      await addDoc(collection(db, 'portfolio'), portfolio);
      window.location.reload(false);
    } catch (error) {
      console.log(error);
      alert('failed to add portfolio', +error);
    }
  };
  const blogForm = useRef();
  const submitBlogItem = (e) => {
    e.preventDefault();
    const name = blogForm.current[0]?.value;
    const description = blogForm.current[1]?.value;
    const image = blogForm.current[2]?.files[0];

    const storageRef = ref(storage, `blog/ ${image.name}`);
    uploadBytes(storageRef, image).then(
      (snapshot) => {
        getDownloadURL(snapshot.ref).then(
          (downloadUrl) => {
            saveBlogItem({
              name,
              description,
              image: downloadUrl,
            });
          },
          (error) => {
            alert(error);
            saveBlogItem({
              name,
              description,
              image: null,
            });
          }
        );
      },
      (error) => {
        alert(error);
        saveBlogItem({
          name,
          description,
          image: null,
        });
      }
    );
  };
  const saveBlogItem = async (blogItem) => {
    console.log(blogItem);
    try {
      await addDoc(collection(db, 'blog'), blogItem);
      window.location.reload(false);
    } catch (error) {
      console.log(error);
      alert('failed to add blog item', +error);
    }
  };

  return (
    <>
      <div className="container dashboard-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={'Dashboard'.split('')}
              idx={15}
            />
          </h1>

          <div className="dashboard-tabs">
            <button
              className={activeTab === 'analytics' ? 'active' : ''}
              onClick={() => setActiveTab('analytics')}
            >
              📊 Analytics
            </button>
            <button
              className={activeTab === 'portfolio' ? 'active' : ''}
              onClick={() => setActiveTab('portfolio')}
            >
              💼 Portfolio
            </button>
            <button
              className={activeTab === 'blog' ? 'active' : ''}
              onClick={() => setActiveTab('blog')}
            >
              📝 Blog
            </button>
            <button className="sign-out-btn" onClick={() => auth.signOut()}>
              🚪 Sign Out
            </button>
          </div>

          <div className="dashboard-content">
            {activeTab === 'analytics' && <AnalyticsDashboard />}

            {activeTab === 'portfolio' && (
              <div>
                <h2>Add Portfolio Item</h2>
                <form ref={form} onSubmit={submitPortfolio}>
                  <p>
                    <input type="text" placeholder="Name" />
                  </p>
                  <p>
                    <textarea placeholder="Description" />
                  </p>
                  <p>
                    <input type="text" placeholder="Url" />
                  </p>
                  <p>
                    <input type="file" placeholder="Image" />
                  </p>
                  <button type="submit">Submit</button>
                </form>
              </div>
            )}

            {activeTab === 'blog' && (
              <div>
                <h2>Add Blog Item</h2>
                <form ref={blogForm} onSubmit={submitBlogItem}>
                  <p>
                    <input type="text" placeholder="Name" />
                  </p>
                  <p>
                    <textarea placeholder="Description" />
                  </p>
                  <p>
                    <input type="file" placeholder="Image" />
                  </p>
                  <button type="submit">Submit</button>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};
export default Home;